import React from 'react';

const Getuser = () => {
    return (
        <div>
            hello
        </div>
    );
}

export default Getuser;
